/**
 * @file automatically generated from MApp.Spatial.Ogc.FontStyle
 */

export enum FontStyle {
    Normal = 0,
    Italic = 1,
    Oblique = 2
}
/**
 * @file automatically generated from MApp.Spatial.Ogc.FontWeight
 */

export enum FontWeight {
    Normal = 0,
    Bold = 1
}
